import { adminHttpClient } from '../../../../commons/adminHttpClinet';
import { UpdateMarketplaceCategoryModel } from './../../../../models/dashboard/marketplace/marketplaceCategoryModel';
const updateCategory = (category: UpdateMarketplaceCategoryModel) => {
    return adminHttpClient.put("/api/Admin/AdminMarketplace/update-category", category);
}
export default updateCategory;